import './TeachingInvolvements.sass';
import SectionHeading from '../../Components/SectionHeading/SectionHeading.js';
import FadeIn from '../../Components/Motion/FadeIn.js';
import Logo from '../../Components/Images/logo.svg';
import STEM from '../../Components/Images/STEM.png';

function ShowTi() {
  const ti = [
    {
      place: 'Cal State LA Technical Interview Preparation for Software Engineers (TIPSE)',
      title: 'Founder and President',
      date: 'Sep 2022 - May 2024',
      content: [
        'Founded and led a student organization to help aspiring software engineers prepare for technical interviews.',
        'Responsible for organizing meetings for members, leading sessions using online resources, facilitating mock interviews, and teaching members common technical interview topics such as BFS/DFS, two-pointers, etc',
      ],
      image: Logo,
      imageBg: '#1f1f1f',
    },
    {
      place: 'STEM Advantage Program',
      title: 'Scholar',
      date: 'October 2022 - Present',
      content: [
        'Cultivated a mentorship relationship with a STEM industry professional with a biweekly touch-base',
        'Participates in professional development workshops and industry career panels.',
      ],
      image: STEM,
    },
  ];

  return (
    <div className="ti_items">
      {ti.map((i, idx) => (
        <FadeIn key={i.place} delay={idx * 0.1} className="ti_items_card">
          <img src={i.image} className="ti_items_card_image" alt={i.place} style={{ background: i.imageBg }} />
          <a href={i.link} className="ti_items_card_link fs2" target="_blank" rel="noopener noreferrer">
            <b>{i.place}</b>
          </a>
          <div className="ti_items_card_title fs1">{i.title}</div>
          <div className="ti_items_card_date fs1">{i.date}</div>
          <ul className="ti_items_card_list">
            {i.content.map((j) => (
              <li className="ti_items_card_maintext bullet fs1" key={j}>{j}</li>
            ))}
          </ul>
        </FadeIn>
      ))}
    </div>
  );
}

function Ti() {
  return (
    <div className="ti_main" id="misc">
      <div className="ti">
        <SectionHeading eyebrow="Beyond Code" text="Miscellaneous Involvements" />
        <ShowTi />
      </div>
    </div>
  );
}

export default Ti;
